import type { TFunction } from 'i18next';

import { hintEntry, nameEntry, type Level, type LevelOffer } from './thinking-levels';

/**
 * A thinking level's name in the UI language: the catalog's for an id it names (lowercased,
 * `none` as Off), else the server's `label`.
 */
export function levelName(t: TFunction<'ai-cio'>, id: string, label: string): string {
  const entry = nameEntry(id);
  return entry ? t(entry[0], entry[1]) : label || id;
}

/** A level's hint, by its rank; the shown model's default's opens with "The default: ". */
export function levelHint(t: TFunction<'ai-cio'>, level: Level, offer: LevelOffer): string {
  const entry = hintEntry(level, offer);
  if (!entry) return '';
  const hint = t(entry[0], entry[1]);
  // An older orchestrator's Low hint already says it is the default.
  if (offer.older || level.id !== offer.defaultId) return hint;
  return t('level.theDefault', 'The default: {{hint}}', {
    hint: hint.charAt(0).toLocaleLowerCase() + hint.slice(1),
  });
}
